export default "__VITE_ASSET__hXiBOmeG__"